<template>
  <div class="jd" :class="{ 'col-md-6': isJDList }">
    <button class="btn-toggle-jd" @click="$emit('toggle')" v-if="isJDList">
      JD詳細を開閉
    </button>
    <div class="jd-header" :class="{ 'margin-0': isDetailModal }">
      <p>JD詳細</p>
    </div>
    <div class="job-description" :class="{ 'jd-list': isJDList }">
      <p>
        JD取込日
        <span class="ml-2">{{ jdDate }}</span>
      </p>
      <div class="job-title mb-3">
        <h2 @click="openJdLink()">{{ job.job_title }}</h2>
      </div>
      <div v-html="job.job_description" class="message-body" v-linkified></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    job: {
      type: Object,
      required: true,
    },
    isJDList: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    jdDate() {
      const { created_date } = this.job;
      return moment(created_date).format('YYYY-MM-DD');
    },
  },
  methods: {
    openJdLink() {
      window.open(this.job.jd_url, '_blank');
    },
  },
};
</script>

<style scoped>
.margin-0 {
  margin-top: 0px !important;
}
.jd-link {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.jd {
  position: relative; /* Add this for button positioning */
}

.btn-toggle-jd {
  width: 40px;
  position: absolute;
  right: -25px; /* Positions button outside the JD panel */
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  padding: 15px 8px;
  background: white;
  color: #000;
  border: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-left: 2px solid white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.job-description {
  max-height: 70vh;
  overflow-y: scroll;
}

h2 {
  cursor: pointer;
  font-size: 20px;
}

.job-description.jd-list {
  max-height: 80vh;
  overflow-y: scroll;
}
.jd-header {
  padding: 2px;
  margin-top: 10px;
  background-color: #036d6c;
}
.jd-header p {
  font-size: 22px;
  color: white;
  font-weight: bold;
  margin: auto;
  padding: 10px;
}
.job-title {
  padding: 20px;
  background: #f0f5f7;
}
.job-description {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  color: #617776;
}

.job-description p {
  font-size: 18px;
}
</style>
